module.exports = __webpack_public_path__ + "static/img/product_img2.31429a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_img2.png
// module id = A1/5
// module chunks = 0